export function getChoicesHint(
  t: (key: string, opts?: object) => string,
  minAnswer: number | null,
  maxAnswer: number | null,
): string {
  if (minAnswer === null && maxAnswer === null) {
    return t('quiz.form.choicesHintUnlimited') as string;
  }
  if (minAnswer !== null && maxAnswer !== null && minAnswer === maxAnswer) {
    return t('quiz.form.choicesHintExact', { count: maxAnswer }) as string;
  }
  if (minAnswer !== null && maxAnswer === null) {
    return t('quiz.form.choicesHintMin', { count: minAnswer }) as string;
  }
  if (maxAnswer !== null && minAnswer === null) {
    return t('quiz.form.choicesHintMax', { count: maxAnswer }) as string;
  }
  // Both defined and different — show min constraint (most user-facing)
  return t('quiz.form.choicesHintMin', { count: minAnswer! }) as string;
}
